import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import DeviceInformation from 'utils/memory-report/memoryReport';
import { buildTimeConfig, Platform } from 'state/configuration/build-time-config';
import { LayoutMode } from 'UI/Layout/Routes/PrimaryNavigation';
import { LayoutComponent } from 'UI/App';

interface ViewportResizePayload {
  width: number;
  height: number;
}

interface SetLayoutParametersPayload {
  viewLayout: LayoutMode;
}

class EventActions {
  public static readonly PREFIX = 'EventActions';

  /* fired for window.onfocus and window.visibilitychange (with document.hidden == false). for detecting wakeups on mobile. */
  static readonly wakeup = createAction(`${this.PREFIX}/wakeup`);
  static readonly viewportResize = createAction<ViewportResizePayload>(`${this.PREFIX}/viewportResize`);

  static readonly setLayoutParameters = createAction<SetLayoutParametersPayload>(`${this.PREFIX}/setLayoutParameters`);

  static readonly setLayoutComponent = createAction<LayoutComponent>(`${this.PREFIX}/setLayoutComponent`);

  static readonly deviceMemoryReport = createAsyncThunk(`${this.PREFIX}/deviceMemoryReport`, async () => {
    if (buildTimeConfig.PLATFORM !== Platform.ANDROID) {
      throw new Error('This action is only meaningful on Android');
    }
    return await DeviceInformation.deviceCharacteristics({});
  });
}

export default EventActions;
